import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

const GOLD     = "#C9A96E";
const INK      = "#1C1915";
const INK_SOFT = "#4A4540";
const BORDER   = "#E7E1D8";
const SOFT_BG  = "#F7F5F2";
const WHITE    = "#FFFFFF";

const card = {
  background: WHITE, border: `1px solid ${BORDER}`,
  borderRadius: 12, padding: "22px 24px", marginBottom: 20,
};
const labelStyle = {
  display: "block", fontSize: 10, letterSpacing: "0.12em",
  textTransform: "uppercase", color: INK_SOFT, marginBottom: 4, fontWeight: 600,
};
const sectionTitle = {
  fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase",
  color: GOLD, marginBottom: 14, fontWeight: 700,
};
const inputStyle = {
  width: "100%", padding: "9px 11px",
  border: `1px solid ${BORDER}`, borderRadius: 7,
  fontSize: 13, color: INK, background: "#FAFAF8",
  boxSizing: "border-box", outline: "none",
};
const taStyle = {
  ...inputStyle, resize: "vertical", minHeight: 90, fontFamily: "inherit",
};

export default function EntreprisePage({ profile }) {
  const [pvList,     setPvList]     = useState([]);
  const [pvSelec,    setPvSelec]    = useState(null);
  const [vue,        setVue]        = useState("liste");
  const [loading,    setLoading]    = useState(false);
  const [msg,        setMsg]        = useState("");

  const [formRep, setFormRep] = useState({
    contenu: "", avancement: 0, type: "reponse",
  });

  useEffect(() => { fetchPV(); }, []);

  async function fetchPV() {
    const { data } = await supabase
      .from("pv_chantier")
      .select("*, projet:projet_id(name)")
      .in("statut", ["soumis", "valide"])
      .order("created_at", { ascending: false });
    if (data) setPvList(data);
  }

  async function handleSoumettre() {
    setLoading(true);
    setMsg("");
    const { error } = await supabase.from("reponses_entreprise").insert({
      pv_id:         pvSelec.id,
      entreprise_id: profile.id,
      type:          formRep.type,
      contenu:       formRep.contenu,
    });
    if (error) { setMsg("Erreur : " + error.message); }
    else {
      setMsg("Réponse envoyée ✓");
      setFormRep({ contenu: "", avancement: 0, type: "reponse" });
      setTimeout(() => setVue("liste"), 1500);
    }
    setLoading(false);
  }

  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("fr-FR", {
    day: "numeric", month: "long", year: "numeric",
  }) : "—";

  const STATUT = {
    soumis: { bg: "#EEF4FD", color: "#2E6DB4", label: "En cours" },
    valide: { bg: "#E8F6EF", color: "#1A7A44", label: "Validé"   },
  };

  // ── Liste des PV ──────────────────────────────────────────────────────────
  if (vue === "liste") return (
    <div style={{ fontFamily: "system-ui, sans-serif", color: INK, maxWidth: 900 }}><div style={{ marginBottom: 28 }}><div style={{ fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: GOLD, marginBottom: 4 }}>
          Espace Entreprise
        </div><div style={{ fontSize: 24, fontWeight: 700 }}>Suivi de chantier</div><div style={{ fontSize: 13, color: INK_SOFT, marginTop: 3 }}>
          Consultez les PV, répondez aux notes et signalez l'avancement
        </div></div>

      {pvList.length === 0 ? (
        <div style={{ ...card, textAlign: "center", padding: 48, color: "#bbb", fontStyle: "italic" }}>
          Aucun PV disponible pour le moment
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {pvList.map(pv => {
            const s = STATUT[pv.statut] || STATUT.soumis;
            return (
              <div key={pv.id}
                onClick={() => { setPvSelec(pv); setVue("detail"); setMsg(""); }}
                style={{
                  ...card, marginBottom: 0, cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16,
                }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.08)"}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
              ><div style={{ flex: 1 }}><div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>
                    {pv.projet?.name || "Projet"} — {fmtDate(pv.date_reunion)}
                  </div><div style={{ fontSize: 12, color: INK_SOFT }}>
                    {pv.lieu || "—"} · Avancement {pv.avancement_global}%
                  </div></div><div style={{ display: "flex", alignItems: "center", gap: 10 }}><span style={{ background: s.bg, color: s.color, borderRadius: 999, padding: "4px 12px", fontSize: 11, fontWeight: 700 }}>
                    {s.label}
                  </span><span style={{ color: "#ccc", fontSize: 18 }}>›</span></div></div>
            );
          })}
        </div>
      )}
    </div>
  );

  // ── Détail PV + formulaire réponse ────────────────────────────────────────
  if (vue === "detail" && pvSelec) return (
    <div style={{ fontFamily: "system-ui, sans-serif", color: INK, maxWidth: 820 }}><div style={{ marginBottom: 24, display: "flex", alignItems: "center", gap: 14 }}><button onClick={() => setVue("liste")}
          style={{ background: "none", border: `1px solid ${BORDER}`, borderRadius: 7, padding: "6px 14px", cursor: "pointer", fontSize: 12, color: INK_SOFT }}>
          ← Retour
        </button><div><div style={{ fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: GOLD }}>
            {pvSelec.projet?.name}
          </div><div style={{ fontSize: 20, fontWeight: 700 }}>PV du {fmtDate(pvSelec.date_reunion)}</div></div></div>

      {msg && (
        <div style={{ marginBottom: 16, padding: "10px 16px", background: "#E8F6EF", borderRadius: 8, fontSize: 13, color: "#1A7A44", fontWeight: 600 }}>
          {msg}
        </div>
      )}

      {/* Infos PV */}
      <div style={card}><div style={sectionTitle}>Compte rendu de réunion</div><div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 16 }}><div><div style={labelStyle}>Lieu</div><div style={{ fontSize: 13 }}>{pvSelec.lieu || "—"}</div></div><div><div style={labelStyle}>Présents</div><div style={{ fontSize: 13 }}>{pvSelec.presents || "—"}</div></div><div><div style={labelStyle}>Avancement global</div><div style={{ fontSize: 26, fontWeight: 800, color: GOLD }}>{pvSelec.avancement_global}%</div></div></div>

        {/* Barre progression */}
        <div style={{ height: 8, background: SOFT_BG, borderRadius: 999, overflow: "hidden", marginBottom: 16 }}><div style={{ height: "100%", width: `${pvSelec.avancement_global}%`, background: `linear-gradient(90deg, ${GOLD}, #E8C87A)`, borderRadius: 999 }} /></div><div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 12 }}>
          {pvSelec.etapes_realisees && (
            <div><div style={labelStyle}>Étapes réalisées</div><div style={{ fontSize: 13, whiteSpace: "pre-wrap", lineHeight: 1.6 }}>{pvSelec.etapes_realisees}</div></div>
          )}
          {pvSelec.etapes_a_venir && (
            <div><div style={labelStyle}>Étapes à venir</div><div style={{ fontSize: 13, whiteSpace: "pre-wrap", lineHeight: 1.6 }}>{pvSelec.etapes_a_venir}</div></div>
          )}
        </div>

        {pvSelec.observations && (
          <div style={{ marginBottom: 12 }}><div style={labelStyle}>Observations</div><div style={{ fontSize: 13, whiteSpace: "pre-wrap", lineHeight: 1.6 }}>{pvSelec.observations}</div></div>
        )}

        {pvSelec.mises_en_demeure && (
          <div style={{ background: "#FDF9F2", borderRadius: 8, padding: "14px 16px", border: "1px solid #F0DEB4" }}><div style={{ ...labelStyle, color: "#C0392B" }}> Mise en demeure</div><div style={{ fontSize: 13, whiteSpace: "pre-wrap", lineHeight: 1.6, color: "#C0392B" }}>
              {pvSelec.mises_en_demeure}
            </div></div>
        )}
      </div>

      {/* Rapport validé si disponible */}
      {pvSelec.statut === "valide" && pvSelec.rapport_final && (
        <div style={card}><div style={sectionTitle}>Rapport officiel</div><div style={{ fontSize: 13, whiteSpace: "pre-wrap", lineHeight: 1.8, color: INK }}>
            {pvSelec.rapport_final}
          </div></div>
      )}

      {/* Formulaire réponse */}
      <div style={card}><div style={sectionTitle}>Votre réponse</div><div style={{ marginBottom: 12 }}><label style={labelStyle}>Type de réponse</label><div style={{ display: "flex", gap: 8 }}>
            {[
              { id: "reponse",    label: " Réponse générale" },
              { id: "avancement", label: " Mise à jour avancement" },
              { id: "document",   label: " Référence document" },
            ].map(t => (
              <button key={t.id} onClick={() => setFormRep(f => ({ ...f, type: t.id }))}
                style={{
                  padding: "7px 14px", borderRadius: 7, fontSize: 12, cursor: "pointer",
                  fontWeight: formRep.type === t.id ? 700 : 400,
                  background: formRep.type === t.id ? INK : SOFT_BG,
                  color: formRep.type === t.id ? WHITE : INK_SOFT,
                  border: `1px solid ${formRep.type === t.id ? INK : BORDER}`,
                }}>
                {t.label}
              </button>
            ))}
          </div></div>

        {formRep.type === "avancement" && (
          <div style={{ marginBottom: 12 }}><label style={labelStyle}>Avancement actuel : <strong style={{ color: GOLD }}>{formRep.avancement}%</strong></label><input type="range" min="0" max="100" step="5" value={formRep.avancement}
              onChange={e => setFormRep(f => ({ ...f, avancement: parseInt(e.target.value) }))}
              style={{ width: "100%", accentColor: GOLD }} /></div>
        )}

        <div style={{ marginBottom: 16 }}><label style={labelStyle}>Message</label><textarea style={taStyle} value={formRep.contenu}
            onChange={e => setFormRep(f => ({ ...f, contenu: e.target.value }))}
            placeholder={
              formRep.type === "reponse"    ? "Votre réponse aux points soulevés dans le PV..." :
              formRep.type === "avancement" ? "Détaillez l'état d'avancement actuel..." :
              "Référencez le document concerné..."
            }
          /></div><div style={{ display: "flex", justifyContent: "flex-end" }}><button onClick={handleSoumettre} disabled={loading || !formRep.contenu}
            style={{
              padding: "10px 24px", background: GOLD, color: WHITE,
              border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700,
              cursor: !formRep.contenu ? "not-allowed" : "pointer",
              opacity: !formRep.contenu ? 0.5 : 1,
            }}>
            {loading ? "Envoi..." : " Envoyer la réponse"}
          </button></div></div></div>
  );

  return null;
}
